import { accountStateBackendUrl, WhitelistState } from './waitlist-api'
import axios from 'axios'

export type ContactType = 'email' | 'discord' | 'twitter'
interface Contact {
  address: string
  type: ContactType
  contact: string
}

export async function isWhitelisted(
  address: string
): Promise<false | WhitelistState> {
  const whitelistedResult = await fetch(
    accountStateBackendUrl + '/whitelisted?address=' + address
  ).then(res => res.json())
  if (whitelistedResult.whitelisted) {
    let state = whitelistedResult.informations as WhitelistState
    state.showContactPopup = false // addon for UI
    state.showDenyPopup = false
    const hasAddedContact = await hasAddedContactToAirtable(address)
    state.contactAdded = hasAddedContact
    return state
  } else {
    return false
  }
}

// GET to know if user was LP
interface LPResponse {
  wasLP: boolean
  receivedXpBonus: boolean
  id: string
}
export async function wasLP(address: string): Promise<LPResponse> {
  const result = await fetch(
    accountStateBackendUrl + '/lp?address=' + address
  ).then(res => res.json())
  return result as LPResponse
}

// PUT a claim to the address
export async function claim(address: string): Promise<void> {
  await fetch(accountStateBackendUrl + '/whitelisted/claim', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ address }),
  })
}

export async function addContactToAirtable(
  address: string,
  contactType: ContactType,
  contact: string
): Promise<void> {
  const contactObj = toContact(address, contactType, contact)
  await fetch(accountStateBackendUrl + '/contacts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contactObj),
  })
}

// For whitelisted users who have already added their contact info
function hasAddedContactToAirtable(address: string): Promise<boolean> {
  return fetch(accountStateBackendUrl + '/contacts?address=' + address).then(
    res => res.json()
  )
}

export async function updateXpBonus(
  address: string,
  zealyId: string
): Promise<any> {
  return axios.put(accountStateBackendUrl + '/lp/xp-bonus', {
    address,
    id: zealyId,
  })
}

export function toContact(
  address: string,
  type: ContactType,
  contact: string
): Contact {
  return {
    address,
    type,
    contact,
  }
}
